import Api from "../../api.js";
import NewUser from "../../schemas/newUser.js";
import { User } from "../../../auth/RoleManager.js";
export const emailReqexp = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
export default class CreateAccount extends Api {
    constructor(app) {
        super("POST", app, "/api/public/users/createAccount", new User(app), {
            rateLimit: { timeWindowSeconds: 60 * 2, max: 10 },
        });
        this.requestSchema = {
            name: {
                required: true,
                type: "string",
                test: (value) => value.length < 512,
            },
            email: {
                required: true,
                type: "string",
                match: emailReqexp,
                test: (value) => value.length < 512,
            },
            phone: {
                required: true,
                type: "string",
                test: (value) => value.length < 512,
            },
            password: {
                required: true,
                type: "string",
                test: (value) => value.length >= 8,
            },
        };
    }
    async post(req, res) {
        var _a, _b, _c, _d;
        const invalidDataResponse = {
            status: 400,
            message: "Invalid parameters",
        };
        const validDataResponse = { status: 200, message: "Success" };
        if (!this.analyzeRequestSchema(this.requestSchema, req.body)) {
            res.status(400).send({
                status: 400,
                message: "Invalid parameters",
                invalidParams: Object.entries(this.requestSchema)
                    .map(([paramName, paramRequirements]) => !this.analyzeRequestParam(paramRequirements, req.body[paramName]) ?
                    paramName
                    : undefined)
                    .filter((paramName) => paramName != null),
            });
            return;
        }
        try {
            const user = new NewUser((_a = req.body) === null || _a === void 0 ? void 0 : _a.name, (_b = req.body) === null || _b === void 0 ? void 0 : _b.email, (_c = req.body) === null || _c === void 0 ? void 0 : _c.phone, (_d = req.body) === null || _d === void 0 ? void 0 : _d.password);
            const userSaved = await this.app.connection.openUserOperations.insertUser(user);
            if (!userSaved) {
                res.status(409).send({ status: 409, message: "User already exists" });
                return;
            }
            // await this.app.accountManager.createAccount( user.email );
            res.send(validDataResponse);
        }
        catch (e) {
            console.warn(e);
            res.status(400).send(invalidDataResponse);
        }
    }
}
